// extracted by mini-css-extract-plugin
module.exports = {"reportListContainer":"ReportList_reportListContainer__3_QQv","header":"ReportList_header__GvmV_","list":"ReportList_list__24ba6"};